<template>
  <div class="step-goals">
    <h2 class="step-title">About you</h2>

    <section class="section">
      <p class="section-label">How long have you been gardening?</p>
      <div class="experience-cards">
        <button
          v-for="opt in experienceOptions"
          :key="opt.value"
          class="experience-card"
          :class="{ selected: wizardData.experience_level === opt.value }"
          type="button"
          @click="setExperience(opt.value)"
        >
          <span class="card-emoji">{{ opt.emoji }}</span>
          <span class="card-label">{{ opt.label }}</span>
        </button>
      </div>
    </section>

    <section class="section">
      <p class="section-label">What do you want from this garden?<br /><small>Pick all that apply</small></p>
      <div class="goals-chips">
        <button
          v-for="goal in goalOptions"
          :key="goal.value"
          class="goal-chip"
          :class="{ selected: wizardData.goals.includes(goal.value) }"
          type="button"
          @click="toggleGoal(goal.value)"
        >
          {{ goal.emoji }} {{ goal.label }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'StepGoals',

  props: {
    wizardData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      experienceOptions: [
        { value: 'beginner', emoji: '🌱', label: 'First season' },
        { value: 'intermediate', emoji: '🌿', label: 'A few seasons' },
        { value: 'expert', emoji: '🌳', label: 'I know my way' },
      ],
      goalOptions: [
        { value: 'feed_family', emoji: '🍅', label: 'Feed my family' },
        { value: 'relax', emoji: '😌', label: 'Relax & grow' },
        { value: 'professional', emoji: '💼', label: 'Track professionally' },
        { value: 'new_varieties', emoji: '🌸', label: 'Try new varieties' },
      ],
    }
  },

  methods: {
    setExperience(value) {
      this.$emit('update:wizardData', {
        ...this.wizardData,
        experience_level: this.wizardData.experience_level === value ? null : value,
      })
    },

    toggleGoal(value) {
      const goals = this.wizardData.goals.includes(value)
        ? this.wizardData.goals.filter((g) => g !== value)
        : [...this.wizardData.goals, value]
      this.$emit('update:wizardData', { ...this.wizardData, goals })
    },
  },
}
</script>

<style scoped>
.step-goals {
  padding-bottom: 8px;
}

.step-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 24px;
}

.section {
  margin-bottom: 28px;
}

.section-label {
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 12px;
  line-height: 1.4;
}

.section-label small {
  font-weight: 400;
  color: #6b7280;
}

.experience-cards {
  display: flex;
  gap: 10px;
}

.experience-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 16px 8px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.experience-card:hover {
  border-color: #a3e635;
}

.experience-card.selected {
  border-color: #65a30d;
  background: #f7fee7;
}

.card-emoji {
  font-size: 1.75rem;
}

.card-label {
  font-size: 0.78rem;
  font-weight: 500;
  text-align: center;
  color: #374151;
}

.goals-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.goal-chip {
  padding: 10px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 999px;
  background: #fff;
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.goal-chip:hover {
  border-color: #a3e635;
}

.goal-chip.selected {
  border-color: #65a30d;
  background: #f7fee7;
}
</style>
